import { Config, AxiosWithJar, Penanggalan } from '@/utility.js'

export default{
	data:()=>({
		hasChild:0,
		finance:{ segment:[], pl:[] },
		shortmonthsname: ["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec"]
	}),
	computed:{
		hasPageChild(){
			return this.$store.getters.pageHadChild
		}
	},
    methods:{

		getYTDfilter(from, to) {
			return from + '=' + Penanggalan().tahunSekarang + '&' + to + '=' + Penanggalan().kemarin
		},

		getMTDfilter(from, to) {
			return from + '=' + Penanggalan().bulanSekarang + '&' + to + '=' + Penanggalan().kemarin
		},

		getYesterdayfilter(from, to) {
			return from + '=' + Penanggalan().kemarin + '&' + to + '=' + Penanggalan().kemarin
		},

		getYTDItem(data, nourut, urutcol) {
			if (data) {
				if (!urutcol) urutcol = "NoUrut";
				for (let i = 0; i < data.length; i++) {
					if (data[i][urutcol] == nourut) return data[i];
				}
			}
			return {};
		},

		processYTD2(data, infoprefix, infocol, valuecol, divcol, groupcol, factor, prec, filtercol, filtervals, divcol2) {
			var rekap = [];
			var group = [];
			var info = [];
			var value = [];
			var div = [];
			var div2 = [];
			var i = 0;
			while (data && i < data.length) {
				var infotext = infoprefix + (infocol ? data[i][infocol] : "")
				var ok = !filtercol;
				if (!ok) {
					for (let j = 0; j < filtervals.length; j++) {
						if (data[i][filtercol] == filtervals[j]) ok = true;
					}
				}
				if (ok) {
					let j = group.indexOf(data[i][groupcol]);
					//console.log("j: " +j);
					if (j == -1) {
						group.push(data[i][groupcol]);
						//console.log("data[i][groupcol]: " + data[i][groupcol]);
						info.push([]);
						value.push([]);
						div.push([]);
						div2.push([]);
						j = group.indexOf(data[i][groupcol]);
					}
					let k = info[j].indexOf(infotext);
					if (k == -1) {
						info[j].push(infotext);
						//console.log("infotext: " + infotext);
						value[j].push(0);
						div[j].push(0);
						div2[j].push(0);
						k = info[j].indexOf(infotext);
					}
					value[j][k] += (data[i][valuecol] / factor);
					div[j][k] += divcol ? (data[i][divcol] * 1) : 0;
					div2[j][k] = divcol2 ? (data[i][divcol2] * 1) : div2[j][k];
					//console.log("infotext: " + valuecol + "###" + infotext + "###" + value[j][k]);
					//console.log("data[i][valuecol] / factor: " + data[i][valuecol] +"/"+ factor+ " === " + value[j][k]);

				}
				i ++;
			}
			for (var n = 0; n < group.length; n++) {
				//console.log("value[n]: " + value[n]);
				for (var m = 0; m < value[n].length; m++) {
					value[n][m] = ((divcol ? (div[n][m] ? value[n][m] / div[n][m] : 0) : value[n][m]) / (divcol2 ? (div2[n][m] ? div2[n][m] : 1) : 1)).toFixed(prec)
					//console.log("value[n][m] " + value[n] + "=== ((" + divcol + "? (" +div[n][m] +"?" + value[n][m] +"/"+ div[n][m] +": 0) : " + value[n][m]) +"/ ("+divcol2 +"? ("+div2[n][m] +"?"+ div2[n][m] +": 1) : 1)))";
				}
				rekap.push({
					Info: info[n],
					Value: value[n],
				});

				//console.log('info: '+info[n]);
				//console.log('value: '+value[n]);
			}
			//console.log(rekap);
			return rekap;
		},

		processYTD(data, infocol, valuecol, divcol, groupcol, factor, prec, filtercol, filtervals, divcol2) {
			return this.processYTD2(data, "", infocol, valuecol, divcol, groupcol, factor, prec, filtercol, filtervals, divcol2);
		},

		processBarChart2(data, infocol, valuecol, divcol, labelcol, factor, prec, colorset, filtercol, filtervals, rev, stacked, infofunc, valuefunc, labelfunc, usetotal, divcol2) {
			var info = [];
			var labels = [];
			var value = [];
			var div = [];
			var div2 = [];
			var datasets = [];
			var i = 0;
			var total = []
			//console.log("data-" + infocol+ "-" + valuecol + ": " + JSON.stringify(data));

			//while (i < data.length) {
			while (i < (Array.isArray(data) ? data.length : 0)) {
				var ok = !filtercol;
				//console.log("filtercol: " + filtercol);
				//console.log("filtervals: " + filtervals);
				//console.log("ok: " + ok);
				if (!ok) {
					for (let j = 0; j < filtervals.length; j++) {
						//console.log("filtercol: " + data[i][filtercol]);
						//console.log("filtervals: " + filtervals[j]);
						if (data[i][filtercol] == filtervals[j]) ok = true;
					}
				}

				if (ok) {
					let lbl = data[i][labelcol] ? data[i][labelcol] : "";
					//console.log("label: " + lbl);
					if (labelfunc) {
						lbl = labelfunc(lbl);
					}
					let k = labels.indexOf(lbl);
					if (k == -1) {
						labels.push(lbl);
						k = labels.indexOf(lbl);
					}
					let inf = data[i][infocol];
					if (infofunc) {
						inf = infofunc(inf);
					}
					let m = info.indexOf(inf);
					if (m == -1) {
						info.push(inf);
						m = info.indexOf(inf);
					}
					while (value.length <= m) {
						value.push([]);
						div.push([]);
						div2.push([]);
					}
					while (value[m].length <= k) {
						value[m].push(0);
						div[m].push(0);
						div2[m].push(0);
					}
					let val = data[i][valuecol];
					if (valuefunc) {
						val = valuefunc(val);
					}
					value[m][k] += (data[i][valuecol] / factor);
					div[m][k] += divcol ? (data[i][divcol] * 1) : 0;
					div2[m][k] = divcol2 ? (data[i][divcol2] * 1) : div2[m][k];
				}
				i ++;
			}

			let maxk = 0;
			for (let i=0;i<value.length;i++) {
				if (maxk < value[i].length) maxk = value[i].length;
			}
			for (let i=0;i<value.length;i++) {
				for (let k=0;k<maxk;k++) {
					value[i][k] = value[i][k] ? value[i][k] * 1 : 0;
				}
			}

			for (let n = rev ? info.length - 1 : 0; (rev && n >= 0) || (!rev && n < info.length); rev ? n-- : n++) {
				for (var m = 0; m < value[n].length; m++) {
					value[n][m] = ((divcol ? (div[n][m] ? value[n][m] / div[n][m] : 0) : value[n][m]) / (divcol2 ? (div2[n][m] ? div2[n][m] : 1) : 1)).toFixed(prec)
					//console.log('value[n][m]: ' + value[n][m])
					while (total.length <= m) total.push(0);
					total[m] += value[n][m] * 1;
				}
				let dat = {
					label: info[n],
					data: value[n],
					backgroundColor: colorset[info[n]] ? colorset[info[n]] : colorset[n],
					//datalabels: { display:true }, //set di component Chart masing2

					//line chart
					borderColor: colorset[info[n]] ? colorset[info[n]] : colorset[n],
					fill: false,
					tension: 0.2, //cure bazier for linechart
				}
				if (stacked) dat.stack = "sum";
				datasets.push(dat);
			}
			for (var x = 0; x < total.length; x++) {
				//console.log('total[x]: ' + total[x]);
				total[x] = (total[x]).toFixed(prec);
			}

			if (usetotal) {
				//console.log(total);
				/*
				datasets.push({
					label:'TOTAL',
					data:total,
					type:'MyLine',
					borderColor:'rgba(0,119,204,.75)',
					borderWidth:4,
					pointRadius:2,
					datalabels: { align: 'top', anchor: 'top', color:'#555', font:{weight:'bold',size:12} },
				})
				*/
			}

			//console.log("labels: "+labels);
			//console.log("datasets: "+  datasets);
			return {
				labels: labels,
				datasets: datasets
			};
		},

		processBarChart(data, infocol, infoprefix, valuecol, divcol, labelcol, labelprefix, factor, prec, colorset, filtercol, filtervals, rev, stacked, divcol2) {
			return this.processBarChart2(data, infocol, valuecol, divcol, labelcol, factor, prec, colorset, filtercol, filtervals, rev, stacked,
				function (x) { return infoprefix + x; }, false, function (x) { return labelprefix + x; }, false, divcol2
			);
		},

		processPieChart(data, valuecol, labelcol, factor, prec, colorset)
        {
			let count = data.length
			var label=[]
			var chartdata=[]
			var dataSet=[]
			var color=[]

			for(let i=0; i<count; i++)
			{
				if(label.indexOf(data[i][labelcol])<0) label.push(data[i][labelcol])

				if(factor !== 0)
				chartdata.push((data[i][valuecol] / factor).toFixed(prec))
				else
				chartdata.push(parseFloat(data[i][valuecol]).toFixed(prec))

				color.push(colorset[data[i][labelcol]])
			}

			var object={data:chartdata,backgroundColor:color}
			dataSet.push(object)

			let datas={
				labels:label,
				datasets:dataSet
			}

			//console.log("data " + JSON.stringify(datas))

			return datas;
        },

		sumData(data, col)
		{
			let sum = 0;
			for(let i=0; i<data.length; i++)
			{
				sum += data[i][col];
			}
			return sum
		},

		formatNum(value, afterComma = 2)
		{
			//console.log('val: ' + value)
			if (typeof value !== "number" || value === "undefined"  || isNaN(value)) {
				//return 0;
				//return value;
			}

			var formatter = new Intl.NumberFormat('id-ID', {
				//style: 'currency', //show currency label
				style: 'decimal',
				currency: 'IDR',
				minimumFractionDigits: afterComma, //0
				maximumFractionDigits: afterComma //0
			});

			if (typeof value === 'undefined')
				return 0;

			if (isNaN(value))
				return 0;

			let cleanValue = value;
			if (value !== null)
				cleanValue = value.toString().replace(',','.');

			//return formatter.format(cleanValue).replace('$','')
			let formattedNumber = formatter.format(cleanValue);
			formattedNumber = formattedNumber.replace(/\./g, '#').replace(/,/g, '.').replace(/#/g, ',');
			return formattedNumber;
		},

		divideNum(value) {
			let result = value
			//console.log('result: ' + result)
			if(isNaN(value)) {
				result = 0
			}
			return result
		},

		createComp(data, infocol, valuecol, idx1, idx2)
		{
			if (!idx1) idx1 = 0;
			if (!idx2) idx2 = 1;

			let res = [];
			res[infocol] = [ data[idx1][infocol], data[idx2][infocol] ];
			res[valuecol] = [ data[idx1][valuecol], data[idx2][valuecol] ];
			//console.dir(res);
			return res;
		},

		async loadSegment() {
			let url = Config().apiURL + "/finance/segment";
			await AxiosWithJar().get(url).then(result=>{
				if(result.data.data.length){
					this.finance.segment = result.data.data;
				}
			})
		},

		async loadPL(dt, level, segment, plant) {
			let url = Config().apiURL + "/finance/pl?dt=" + (dt ? dt : Penanggalan().bulanKemarin) + (plant ? "&plantno=" + plant : "") + (segment ? "&segment=" + segment : "") +
				(level ? "&level=" + level : "");
			await AxiosWithJar().get(url).then(result=>{
				if(result.data.data.length){
					this.finance.pl = result.data.data;
				}
			})
		},

		hideNonChildren(){
			this.$store.commit('updatePageHadChild',1)
			this.hasChild=this.$store.getters.pageHadChild
		},

		createOptions(data, valueField, nameField) {
			let opts=[]
			for(let i=0; i<data.length; i++)
			{
				opts.push({ value:data[i][valueField], name:data[i][nameField] })
			}
			return opts
		},

		getoption(value, options) {
			for (let i = 0; i < options.length; i++) {
				if (options[i].value == value) return options[i]
			}
			return null
		},

		getShortMonthName(monthNumber) {
			const months = [
				"Jan", "Feb", "Mar", "Apr", "May", "Jun","Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
			];

			if (monthNumber >= 1 && monthNumber <= 12) {
				return months[monthNumber - 1];
			} else {
				return "-";
			}
		},

		getMonthName(monthNumber) {
			const months = [
				"January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"
			];

			if (monthNumber >= 1 && monthNumber <= 12) {
				return months[monthNumber - 1];
			} else {
				return "-";
			}
		},

		getLastYears(yearsToShow = 5) {
			const currentYear = new Date().getFullYear();

			let recentData = []; // Reset recentData
			for (let i = 0; i < yearsToShow; i++) {
				const year = currentYear - i;
				recentData.push({
					value: year,
					name: year
				});
			}
			//console.log('years: ' + JSON.stringify(recentData));
			return recentData;
		},

		getMonthList() {
			let recentData = [];
			recentData.push({ value: 1, name: 'January'});
			recentData.push({ value: 2, name: 'February'});
			recentData.push({ value: 3, name: 'March'});
			recentData.push({ value: 4, name: 'April'});
			recentData.push({ value: 5, name: 'May'});
			recentData.push({ value: 6, name: 'June'});
			recentData.push({ value: 7, name: 'July'});
			recentData.push({ value: 8, name: 'August'});
			recentData.push({ value: 9, name: 'September'});
			recentData.push({ value: 10, name: 'October'});
			recentData.push({ value: 11, name: 'November'});
			recentData.push({ value: 12, name: 'December'});
			return recentData;
		},

		//Untuk mengecek apakah date range masuk kategori tahun 2025 ke atas, atau 2024 kebawah, ataupun keduanya
		getYearCategory(dateRange) {
			const dateString = String(dateRange);
			// Split the string by comma
			const dateArray = dateString.split(',');

			// Convert the date strings to Date objects
			const date1 = new Date(dateArray[0]);
			const date2 = new Date(dateArray[1]);

			// Get the year of both dates
			const year1 = date1.getFullYear();
			const year2 = date2.getFullYear();

			// Check if both dates are 2025 or later
			const all2025OrAbove = year1 >= 2025 && year2 >= 2025;

			// Check if both dates are 2024 or earlier
			const all2024OrBelow = year1 <= 2024 && year2 <= 2024;

			// Check if it's a mix of both
			const mixed = !(all2025OrAbove || all2024OrBelow);

			if (all2025OrAbove) {
				return 1; //return "All dates are 2025 or later";
			} else if (all2024OrBelow) {
				return 2; // "All dates are 2024 or earlier";
			} else if (mixed) {
				return 3; // "There are dates from 2025 or later and 2024 or earlier";
			}
		},

		getYearCategory2(dateRange) {
			const dateString = String(dateRange);
			// Split the string by comma
			const dateArray = dateString.split(',');

			// Add '-01' to both dates to assume the 1st day of the month
			const date1 = new Date(dateArray[0] + '-01');
			const date2 = new Date(dateArray[1] + '-01');

			// Get the year of both dates
			const year1 = date1.getFullYear();
			const year2 = date2.getFullYear();

			// Check if both dates are 2025 or later
			const all2025OrAbove = year1 >= 2025 && year2 >= 2025;

			// Check if both dates are 2024 or earlier
			const all2024OrBelow = year1 <= 2024 && year2 <= 2024;

			// Check if it's a mix of both
			const mixed = !(all2025OrAbove || all2024OrBelow);

			if (all2025OrAbove) {
				return 1; // "All dates are 2025 or later";
			} else if (all2024OrBelow) {
				return 2; // "All dates are 2024 or earlier";
			} else if (mixed) {
				return 3; // "There are dates from 2025 or later and 2024 or earlier";
			}
		},
		columnXLSX(_reportdata)
		{
			let labels=[];
			if (_reportdata['columns']) {
				let columns = _reportdata['columns'];
				for(var i=0; i<columns.length; i++){
					let dt = {}
					dt['field'] = columns[i].field;
					dt['label'] = columns[i].title;
					labels.push(dt);
				}
			}
			return labels;
		},
		dataXLSX(_reportdata) {
			let rows=[];
			if (_reportdata['columns']) {
				rows = _reportdata['data'];
			}
			return rows;
		},

        formatDate(dateString, inputFormat = 'YYYY-MM-DDTHH:mm:ss', outputFormat = 'dd MMM yyyy') {
            // Check if the input format is valid and if it's just a date (YYYY-MM-DD)
            let date;

            // If the input format is just a date (YYYY-MM-DD), add default time (T00:00:00)
            if (inputFormat === 'YYYY-MM-DD') {
                if (dateString.indexOf('T') === -1) {
                    dateString += 'T00:00:00'; // Add default time if there is no time part in the input
                }
            }

            // Attempt to convert the string to a Date object
            date = new Date(dateString);

            // If the Date object is invalid, return the original string
            if (isNaN(date.getTime())) {
                return dateString; // Return the original string if the date format is invalid
            }

            // Format output according to the Indonesian locale (default format)
            const options = {
                day: '2-digit',
                month: 'short',
                year: 'numeric'
            };

            // If the output format is 'dd MMM yyyy', return the formatted date
            if (outputFormat === 'dd MMM yyyy') {
                return new Intl.DateTimeFormat('id-ID', options).format(date); // Example: 14 Jun 2025
            }

            // If other output formats are needed, add additional checks here
            // Example: for 'yyyy-MM-dd' format
            if (outputFormat === 'yyyy-MM-dd') {
                return date.toLocaleDateString('id-ID', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit'
                }).replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$3-$2-$1'); // Format as 2025-06-14
            }

            // Default: return the date in the default format (dd MMM yyyy)
            return date.toLocaleDateString('id-ID', options);  // Example: 14 Jun 2025
        }

	}
}
